// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"LoadingWrapper_loadingWrapper__zQXVi","loading":"LoadingWrapper_loading__c1dfS","spin":"LoadingWrapper_spin__dIeE+"};